import {
  PublicClientApplication,
  BrowserCacheLocation,
  IPublicClientApplication,
  InteractionType,
} from '@azure/msal-browser';

import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';

import { environment } from '../../../environments/environment';

export function MSALInstanceFactory(): IPublicClientApplication {
  const redirectUri = `${window.location.origin}/${environment.Azure.ActiveDirectory.RedirectUri}`;
  return new PublicClientApplication({
    auth: {
      clientId: environment.Azure.ActiveDirectory.ClientId,
      authority: environment.Azure.ActiveDirectory.Authority,
      redirectUri,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
    },
  });
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ['User.Read'],
    },
  };
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, string[]>();

  protectedResourceMap.set(environment.Azure.GraphEndpoint, ['User.Read']);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}
